// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  background: var(--clr-primary);
  padding: 15px 0;
}

.footer__label {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-family: "Jost";
  color: var(--clr-gray200);
  margin: 1.5rem 0 0.25rem 0;
}

.footer__links a {
  font-weight: 200;
  font-size: 0.9rem;
  color: var(--clr-gray200);
  margin-top: 0.7rem;
  letter-spacing: 0.05rem;
  transition: all 0.15s ease;
}

.footer__links {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  margin: 0 auto;
  justify-content: space-between;
}
.footer__links > div {
  display: flex;
  flex-flow: column nowrap;
  margin-right: 48px;
}

.footer__bottom > div:first-of-type {
  display: flex;
  flex-direction: column;
}

.footer__bottom .social-media-links svg {
  background-color: #fff1;
  border-radius: 50%;
  padding: 0.2em;
  fill: var(--clr-light);
  height: 32px;
  margin: 0.3rem 8px 0.3rem 0;
}

.footer__bottom {
  display: flex;
  justify-content: space-between;
  background: var(--clr-primary);
  border-top: 0.2rem solid var(--clr-gray200);
  padding-top: 4em;
  margin-top: 4em;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding-top: 10px;
  margin-top: 20px;
}

.footer__bottom span {
  color: var(--clr-gray200);
  font-size: 0.85rem;
  margin-top: 1rem;
  /* color: var(--clr-gray500); */
}
.footer__bottom > div:first-of-type span:last-of-type {
  margin-top: 0.5rem;
}

.footer__socialLinks {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.footer__socialLinks svg {
  width: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["footer {\n  background: var(--clr-primary);\n  padding: 15px 0;\n}\n\n.footer__label {\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 1.1rem;\n  letter-spacing: 0.05rem;\n  font-family: \"Jost\";\n  color: var(--clr-gray200);\n  margin: 1.5rem 0 0.25rem 0;\n}\n\n.footer__links a {\n  font-weight: 200;\n  font-size: 0.9rem;\n  color: var(--clr-gray200);\n  margin-top: 0.7rem;\n  letter-spacing: 0.05rem;\n  transition: all 0.15s ease;\n}\n\n.footer__links {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-start;\n  margin: 0 auto;\n  justify-content: space-between;\n}\n.footer__links > div {\n  display: flex;\n  flex-flow: column nowrap;\n  margin-right: 48px;\n}\n\n.footer__bottom > div:first-of-type {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer__bottom .social-media-links svg {\n  background-color: #fff1;\n  border-radius: 50%;\n  padding: 0.2em;\n  fill: var(--clr-light);\n  height: 32px;\n  margin: 0.3rem 8px 0.3rem 0;\n}\n\n.footer__bottom {\n  display: flex;\n  justify-content: space-between;\n  background: var(--clr-primary);\n  border-top: 0.2rem solid var(--clr-gray200);\n  padding-top: 4em;\n  margin-top: 4em;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  padding-top: 10px;\n  margin-top: 20px;\n}\n\n.footer__bottom span {\n  color: var(--clr-gray200);\n  font-size: 0.85rem;\n  margin-top: 1rem;\n  /* color: var(--clr-gray500); */\n}\n.footer__bottom > div:first-of-type span:last-of-type {\n  margin-top: 0.5rem;\n}\n\n.footer__socialLinks {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.footer__socialLinks svg {\n  width: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
